/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingdeletepost2Inputs */

const en_crosspostingdeletepost2 = /** @type {(inputs: Crosspostingdeletepost2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete post`)
};

const de_crosspostingdeletepost2 = /** @type {(inputs: Crosspostingdeletepost2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag löschen`)
};

/**
* | output |
* | --- |
* | "Delete post" |
*
* @param {Crosspostingdeletepost2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingdeletepost2 = /** @type {((inputs?: Crosspostingdeletepost2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingdeletepost2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingdeletepost2(inputs)
	return de_crosspostingdeletepost2(inputs)
});
export { crosspostingdeletepost2 as "crosspostingDeletePost" }